import { styled, css } from '@mui/material';

import { LoaderStyleProps } from '@/components/Loader/LoaderTypes';

import { ZINDEX } from '@/resources/constants';

import transientProps from '@/utils/transientProps';

export const StyledLoader = styled('div', transientProps)<LoaderStyleProps>`
  display: flex;
  align-items: center;

  ${({ $isJustifyCenter }) =>
    $isJustifyCenter &&
    css`
      justify-content: center;
    `}

  ${({ $isStatic }) =>
    !$isStatic &&
    css`
      top: 0;
      left: 0;
      position: absolute;
      width: 100%;
      height: 100%;
      z-index: ${ZINDEX.LOADER};
      background: rgba(255, 255, 255, 0.5);
    `}

  color: #c1c1c1;
`;
